<template>
    <main-container>
        <v-container class="convention-menu">
            <v-row>
                <v-col>
                    <convention-menu-item
                        to="/presentation"
                        :label="this.$privateDico.convention.menu.presentation.label"
                    />
                </v-col>
                <v-col>
                    <convention-menu-item
                        to="/champ-dapplication"
                        :label="this.$privateDico.convention.menu.ca.label"
                        :hasExclusions="hasExclusions"
                    />
                </v-col>
                <v-col>
                    <convention-menu-item
                        to="/obligations"
                        :label="this.$privateDico.convention.menu.obligations.label"
                    />
                </v-col>
                <v-col v-if="hasCompactInfo && isSubscribedToCompactInfo">
                    <convention-menu-item
                        to="/compact-info"
                        :label="this.$privateDico.convention.menu['compact-info'].label"
                    >
                        <template v-slot:icon>
                            <compact-info-icon />
                        </template>
                    </convention-menu-item>
                </v-col>
            </v-row>
        </v-container>
    </main-container>
</template>

<script>
import ConventionMenuItem from "./ConventionMenuItem.vue";
import compactInfoManager from "./compact-info/managers/compactInfoManager";
import { isArray } from "lodash";
import CompactInfoIcon from "src/components/common/icons/CompactInfoIcon.vue";
import userMixin from "src/mixins/user";

export default {
    components: { ConventionMenuItem, CompactInfoIcon },
    props: ["convention", "user"],
    mixins: [userMixin],
    computed: {
        hasCompactInfo() {
            const compactInfoAnnotations = compactInfoManager.filterCompactInfoAnnotations(
                this.convention
            );
            return Object.keys(compactInfoAnnotations).length > 0;
        },
        hasExclusions() {
            return (
                isArray(this.convention.excludedActivities) &&
                this.convention.excludedActivities.length > 0
            );
        },
    },
};
</script>

<style scoped lang="sass">
.convention-menu
    padding: 0

@media print
    .convention-menu
        margin-top: 10mm
    .row
        display: block
        margin: 0

    .col
        padding: 0
        flex: 0 0 auto
        max-width: 100%
        width: auto
</style>
